import { useEffect, useRef } from 'react';
// import { GridStack, type GridStackOptions, type GridStackWidget } from 'gridstack';
import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.min.css';
import { Card } from '@components/card/card';

type ItemType = {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  //   content: JSX.Element;
  content: React.ReactNode;
};

export const BuildGrid2 = ({
  dashboardItems,
  setItemsForUpdate
}: {
  dashboardItems: ItemType[];
  setItemsForUpdate: any;
}) => {
  const gridRef = useRef<HTMLDivElement>(null);
  const refs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const gridInstanceRef = useRef<GridStack | null>(null);

  useEffect(() => {
    if (gridRef.current) {
      // إذا كان هناك نسخة سابقة، ندمّرها
      if (gridInstanceRef.current) {
        gridInstanceRef.current.destroy(false); // false يعني لا تحذف العناصر من DOM
      }

      const grid = GridStack.init(
        {
          column: 12,
          margin: 5,
          float: true,
          resizable: {
            handles: 'all'
          },
          draggable: {
            handle: '.grid-stack-item-content'
          }
        },
        gridRef.current
      );
      // حفظ النسخة في المرجع
      gridInstanceRef.current = grid;

      grid.on('change', function (event, changedItems) {
        // نحصل على جميع العناصر الحالية من الشبكة
        const allItems: any[] = grid.save(false); // false => لا تحفظهم في localStorage، فقط ترجعهم

        const updatedItems = allItems?.map((item: any) => ({
          id: item.id,
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h
        }));
        setItemsForUpdate(updatedItems);

        // console.log('جميع العناصر بعد التغيير:', updatedItems);

        // إرسالهم مثلاً لحفظ الترتيب الجديد
        // onLayoutChange?.(updatedItems);
      });
    }
  }, [dashboardItems]);

  return (
    <>
      <div className='grid-stack' ref={gridRef}>
        {dashboardItems?.map(item => (
          <div
            key={item.id}
            ref={el => {
              refs.current[item.id] = el;
            }}
            className='grid-stack-item'
            gs-id={item.id}
            gs-w={item.w}
            gs-h={item.h}
            gs-x={item.x}
            gs-y={item.y}
          >
            <Card className='grid-stack-item-content'>{item.content}</Card>
          </div>
        ))}
      </div>
    </>
  );
};
